<template>
  <a-modal
    ref="createModal"
    title="新建产品产线"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="manufactureBaseCodeTitle">
        <i class="toRequired">*</i>生产基地
      </span>
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <span slot="prodLineCodeTitle">
        <i class="toRequired">*</i>产线说明
      </span>
      <span slot="itemCodeTitle">
        <!-- <i class="toRequired">*</i> -->
        物料编码
      </span>
      <!-- <span slot="capacityTypeTitle">
        <i class="toRequired">*</i>产能类型
      </span> -->
      <span slot="unitCapacityTitle">
        <i class="toRequired">*</i>产能(套/时)
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(tableList, record)">删除</a>
          </span>
          <span v-else-if="item.dataIndex === 'itemIdTem'">
            <global-select
              :value.sync="record.itemIdTem"
              selectType="selectAssembleSearch"
              requestApi="/mes/mesDiscreteJobs/assemblyBox"
              :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
              searchParam="itemCode"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
              @change="(val, list)=>{globalSelectChange(val, list,record) } " />
          </span>

          <span v-else-if="item.type === 'select'">
            <global-select
              @change="(val, list)=>{ handleGSChange(val,list,item,record)}"
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label, thirdLabel: item.thirdLabel }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled ? item.disabled : false" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" @change="inputNumberChange(record, item.dataIndex)" />
          </span>
          <span v-else-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusOnChange(record, item.dataIndex)" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiBomProdLineAssignAdd } from '@/api/mes/basedata/productProductionLine'
import { apiGetInventOrgList } from '@/api/mes/basedata/productionLine'

export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopCodeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    manufactureBaseCodeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      organizationList: [], // 加工组织下拉数据
      columns: [
        {
          // title: '生产基地',
          dataIndex: 'manufactureBaseCode',
          scopedSlots: { customRender: 'manufactureBaseCode', title: "manufactureBaseCodeTitle" },
          width: 150,
          type: "select",
          dataList: 'manufactureBaseCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          // title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" },
          width: 150,
          type: "select",
          selectType: "selectAssemble",
          dropdownMatchSelectWidth: false,
          assembleLabel: true,
          // requestApi: "/system/user/inventOrgList",
          dataList: 'organizationList',
          value: 'realValue',
          label: 'label'
        },
        // {
        //   title: '供应商',
        //   dataIndex: 'supplierName',
        //   scopedSlots: { customRender: 'supplierName' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '供应商简称',
        //   dataIndex: 'supplierCode',
        //   scopedSlots: { customRender: 'supplierCode' },
        //   width: 150,
        //   type: "input"
        // },
        {
          // title: '产线编码',
          dataIndex: 'prodLineCode',
          scopedSlots: { customRender: 'prodLineCode', title: "prodLineCodeTitle" },
          width: 150,
          type: "select",
          setParams: true,
          sourseField: "res",
          requestApi: "/bom/bomProdLine/findList",
          value: 'prodLineCode',
          label: 'prodLineDesc'
        },
        // {
        //   title: '产线说明',
        //   dataIndex: 'prodLineDesc',
        //   scopedSlots: { customRender: 'prodLineDesc' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '标准总人数',
        //   dataIndex: 'totalNumOfPeople',
        //   scopedSlots: { customRender: 'totalNumOfPeople' },
        //   width: 150,
        //   type: "inputNumber"
        // },
        // {
        //   title: '总人员配置',
        //   dataIndex: 'personnelAllocation',
        //   scopedSlots: { customRender: 'personnelAllocation' },
        //   width: 150,
        //   type: "input"
        // },
        {
          title: '工厂级标准参考产品',
          dataIndex: 'refProductFactory',
          scopedSlots: { customRender: 'refProductFactory' },
          width: 160,
          align: 'center',
          type: 'switch'
        },
        {
          title: '产线级标准参考产品',
          dataIndex: 'refProductLine',
          scopedSlots: { customRender: 'refProductLine' },
          width: 160,
          align: 'center',
          type: 'switch'
        },
        {
          title: '人员级标准参考产品',
          dataIndex: 'refProductPersonnel',
          scopedSlots: { customRender: 'refProductPersonnel' },
          width: 160,
          align: 'center',
          type: 'switch'
        },
        {
          // title: '物料编码',
          dataIndex: 'itemIdTem',
          scopedSlots: { customRender: 'itemIdTem', title: "itemCodeTitle" },
          width: 150,
          type: "select",
          selectType: "selectAssembleSearch",
          assembleLabel: true,
          requestApi: "/mes/mesDiscreteJobs/assemblyBox",
          searchParam: "itemCode",
          value: 'realValue',
          label: 'selectedValue',
          thirdLabel: "bringOutDataOne",
          dropdownMatchSelectWidth: false
        },
        // {
        //   title: '项目组',
        //   dataIndex: 'projectTeam',
        //   scopedSlots: { customRender: 'projectTeam' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '销售类目',
        //   dataIndex: 'salesCategory',
        //   scopedSlots: { customRender: 'salesCategory' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '系列/主型号',
        //   dataIndex: 'foldNumber',
        //   scopedSlots: { customRender: 'foldNumber' },
        //   width: 150,
        //   type: "input"
        // },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' },
          width: 150,
          type: "input",
          disabled: true
        },
        // {
        //   title: '物料描述',
        //   dataIndex: 'specification',
        //   scopedSlots: { customRender: 'specification' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '工艺分层',
        //   dataIndex: 'techniqueStructure',
        //   scopedSlots: { customRender: 'techniqueStructure' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '产品族',
        //   dataIndex: 'productGroup',
        //   scopedSlots: { customRender: 'productGroup' },
        //   width: 150,
        //   type: "input"
        // },
        // {
        //   title: '瓶颈工序CT（套/分钟）',
        //   dataIndex: 'cycleTime',
        //   scopedSlots: { customRender: 'cycleTime' },
        //   width: 190,
        //   type: "inputNumber"
        // },
        {
          title: '排线优先顺序',
          dataIndex: 'linePriority',
          scopedSlots: { customRender: 'linePriority' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '产线等价系数',
          dataIndex: 'coefficient',
          scopedSlots: { customRender: 'coefficient' },
          width: 150,
          type: "inputNumber"
        },
        // {
        //   // title: '产能类型',
        //   dataIndex: 'capacityType',
        //   scopedSlots: { customRender: 'capacityType', title: "capacityTypeTitle" },
        //   width: 150,
        //   type: "select",
        //   dataList: 'capacityTypeList',
        //   value: 'lookupCode',
        //   label: 'lookupValue'
        // },
        // {
        //   title: '产能效率(套/分钟)',
        //   dataIndex: 'efficiency',
        //   scopedSlots: { customRender: 'efficiency' },
        //   width: 150,
        //   type: "inputNumber"
        // },
        {
          // title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          scopedSlots: { customRender: 'unitCapacity', title: "unitCapacityTitle" },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: []
    }
  },
  created () {
    this.initInventOrg()
  },
  methods: {
    globalSelectChange (val, list, record) {
      const seletItem = list.find(item => {
        return item.selectedValue === val
      })
      record.itemId = seletItem.realValue
      record.itemName = seletItem.bringOutDataTwo
    },
    handleGSChange (value, list, item, record) {
      if (item.dataIndex === 'prodLineCode') {
        const filteredRecords = list.filter(obj => obj.prodLineCode === value);
        if (filteredRecords) {
          record.prodLineId = filteredRecords[0].id
        }
      }
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        manufactureBaseCode: "",
        organizationCode: "",
        // supplierName: "",
        // supplierCode: "",
        prodLineCode: "",
        // prodLineDesc: "",
        // totalNumOfPeople: "",
        // personnelAllocation: "",
        refProductFactory: "",
        refProductLine: "",
        refProductPersonnel: "",
        itemIdTem: "",
        itemId: "",
        // projectTeam: "",
        // salesCategory: "",
        // foldNumber: "",
        itemName: "",
        // specification: "",
        // techniqueStructure: "",
        // productGroup: "",
        linePriority: "",
        coefficient: "",
        // capacityType: "",
        // efficiency: "",
        unitCapacity: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 初始化获取加工组织
    initInventOrg() {
      this.organizationList = []
      apiGetInventOrgList({ pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 200 && res?.rows?.length > 0) {
          this.organizationList = res.rows || []
        }
      })
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].manufactureBaseCode ||
        !this.tableList[i].organizationCode ||
        !this.tableList[i].prodLineCode
        // !this.tableList[i].itemId
        ) {
          this.$message.warning('必填项不能为空')
          flag = true
          return
        }
        if (!this.tableList[i].unitCapacity || Number(this.tableList[i].unitCapacity) <= 0) {
          this.$message.warning('产能(套/时) 不能为空且需大于0')
          flag = true
          return
        }
        if (this.tableList[i].linePriority === 0) {
          this.$message.warning('排线优先顺序需大于0')
          flag = true
          return
        }
        if (this.tableList[i].coefficient === 0) {
          this.$message.warning('产线等价系数需大于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiBomProdLineAssignAdd(this.tableList).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "prodLineCode") {
        return record.organizationCode ? { organizationCode: record.organizationCode } : {}
      }
      if (dataIndex === "organizationCode") {
        return { pageNum: 1, pageSize: 999 }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    inputNumberChange (record, dataIndex) {
      // if (dataIndex === "cycleTime") {
      //   record.unitCapacity = this.$parseFloatToFixed(60 / Number(record.cycleTime), 6)
      // }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 130px !important;
}
/deep/.ant-input-number{
  width: 130px !important;
}
/deep/.ant-select{
  width: 130px !important;
}
</style>
